import ExpandedProcessTileDataGetter from "components/Dashboard/Tiles/ProcessTile/ExpandedTile/ExpandedProcessTileDataGetter";
import { uniqBy } from "lodash";
import { useMemo } from "react";
import { Process } from "types/types";
import {
  useGetPageFromPath,
  useVisibleGroups,
} from "utils/customHooks/genericHooks";

export function AllExpandedProcessTilesGetter() {
  // midgard operatiles on Process Tiles page
  const visibleGroups = useVisibleGroups();
  const { isAllWorkSchedulesPage, isProcessTilesPage } = useGetPageFromPath();
  const shouldFetchAllGroups = isAllWorkSchedulesPage && isProcessTilesPage;
  const processes = useMemo(
    () =>
      shouldFetchAllGroups
        ? uniqBy(
            visibleGroups.reduce<Process[]>(
              (acc, group) => [...acc, ...group.processes],
              []
            ),
            "id"
          )
        : visibleGroups[0].processes,
    [shouldFetchAllGroups, visibleGroups]
  );
  return (
    <>
      {processes.map(process => (
        <ExpandedProcessTileDataGetter
          key={process.id}
          processId={process.id}
        />
      ))}
    </>
  );
}
